import '../styles/exh.css';
import 'hammerjs';

$('document').ready(function() {
  var button = document.getElementById('audio_button');
  if (button) {
    button.addEventListener('click', audio_play);
    function audio_play() {
      let audio = document.getElementById('audio_without_controls');
      if (audio.paused || audio.ended) {
        audio.play();
        button.style.backgroundImage = 'url("/images/icon-audio-stopp.svg")';
      } else {
        audio.pause();
        button.style.backgroundImage = 'url("/images/icon-audio-play.svg")';
      }
    }
  }

  const buttons = document.getElementsByClassName('button-js');
  let input = document.getElementById('input');
  let output = document.getElementById('output');

  let i;
  for (i = 0; i < buttons.length; i++) {
    let singleButton = buttons[i];
    if (singleButton.value.length == 1) {
      singleButton.addEventListener('click', event => {
        if (input.value.length < 4) {
          input.value += event.target.value.toString();
          output.textContent = '';
        }
      });
    }
  }
  if (document.getElementById('delete') != null) {
    document.getElementById('delete').addEventListener('click', event => {
      input.value = '';
    });
  }

  if (document.getElementById('ready') != null) {
    document.getElementById('ready').addEventListener('click', event => {
      if (input.value.length > 0) {
        window.location.href = '/show_identifier/' + input.value;
      } else {
        window.history.back();
      }
    });
  }

  var epochElements = document.getElementsByClassName('epoch');

  function toggleInvisible(epochElement) {
    if (
      !epochElement.parentElement.parentElement
        .querySelector('.epoch-container')
        .classList.contains('invisible')
    ) {
      epochElement.parentElement.parentElement
        .querySelector('.epoch-container')
        .classList.add('invisible');
    } else {
      for (i = 0; i < epochElements.length; i++) {
        epochElements[i].parentElement.parentElement
          .querySelector('.epoch-container')
          .classList.add('invisible');
      }
      epochElement.parentElement.parentElement
        .querySelector('.epoch-container')
        .classList.remove('invisible');
    }
  }

  for (i = 0; i < epochElements.length; i++) {
    let functionCallRemove = function() {
      toggleInvisible(this);
    };
    epochElements[i].addEventListener('click', functionCallRemove);
  }

  let slides = document.getElementsByClassName('slides');
  if (slides.length >= 2) {
    var slideIndex = 1;
    showSlides(slideIndex);
    var prev = function() {
      plusSlides(-1);
    };
    var next = function() {
      plusSlides(1);
    };

    // This method is responsible for the swipe ability of the imageslider of the exh show page
    const initSlider = () => {
      document.querySelectorAll('.swipable').forEach(swipable => {
        const hammer = new Hammer(swipable);
        // This is responsible for the movement of the image when swiped and can be turned off or substituted by other transformations
        hammer.on('panmove', ev => {
          swipable.style.transform = `translate(${ev.deltaX}px,0)`;
        });
        hammer.on('hammer.input', ev => {
          if (ev.isFinal) {
            swipable.style.transform = 'translate(0,0)';
          }
        });
        // This triggers the prev or next method when swiped left or right
        hammer.on('swiperight', () => {
          prev();
        });
        hammer.on('swipeleft', () => {
          next();
        });
      });
    };

    document.getElementsByClassName('prev')[0].addEventListener('click', prev);
    document.getElementsByClassName('next')[0].addEventListener('click', next);

    // Next/previous controls
    function plusSlides(n) {
      showSlides((slideIndex += n));
    }

    function showSlides(n) {
      var i;
      var slides = document.getElementsByClassName('slides');
      var dots = document.getElementsByClassName('dot');
      if (n > slides.length) {
        slideIndex = 1;
      }
      if (n < 1) {
        slideIndex = slides.length;
      }
      for (i = 0; i < slides.length; i++) {
        slides[i].style.display = 'none';
      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(' active', '');
      }
      slides[slideIndex - 1].style.display = 'block';
      dots[slideIndex - 1].className += ' active';
    }
    initSlider();
  }
});
